export const API_URL = process.env.VUE_APP_URL;
export const STYLES_URL = process.env.VUE_APP_ASSETS_URL + 'styles/';
export const IMAGES_URL = process.env.VUE_APP_ASSETS_URL + 'images/';
export default API_URL;
